import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

let messages = {
  'ca-ES': require('../locales/messages_ca-ES.json'),
  'en-GB': require('../locales/messages_en-GB.json'),
  'es-ES': require('../locales/messages_es-ES.json'),
  'es-CL': require('../locales/messages_es-CL.json'),
};

export default function(lang) {
  return new VueI18n({
    locale: lang,
    messages
  });
}
